// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  GetWebSessionStatusData,
  GetWebSessionStatusErrors,
  GetWebSessionStatusResponses,
  InitiateWebSessionData,
  InitiateWebSessionErrors,
  InitiateWebSessionResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Initiate a Web Session flow from the given parameters:
 * - The `audience` value is given during integration for each client.
 * - A `secret` nonce generated randomly in the client.
 *
 * In response, the flow's identifier `code` and its expiry are returned.
 *
 * This endpoint starts the authentication flow as described below:
 * 1. Initiate the flow with a `secret`, getting back its `code`.
 * 2. Construct a universal link of the form https://swissborg.com/wa/v1/web/login/{code} and
 * share it with the user either as a QR code or a button.
 * 3. Poll the status endpoint to retrieve the session token, or until the deadline `expires_at` is reached.
 *
 */
export const initiateWebSession = <ThrowOnError extends boolean = false>(
  options: Options<InitiateWebSessionData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    InitiateWebSessionResponses,
    InitiateWebSessionErrors,
    ThrowOnError
  >({
    url: "/web-auth/session/setup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get the Web Session flow status and its associated session token if successfully completed.
 * A polling of 1 second should be used to get the latest status, until a terminal state is reached.
 *
 */
export const getWebSessionStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetWebSessionStatusData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    GetWebSessionStatusResponses,
    GetWebSessionStatusErrors,
    ThrowOnError
  >({
    url: "/web-auth/session/status/{code}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};
